<template>
    <div class="drawerLayer" v-show="visible">
        <div class="mask" @click="close();"></div>
        <div class="bottomDrawer white_bg hiddenScrollbar" style="max-height: 90%; overflow: auto">
            <div class="generalPagePaddingH">
                <header class="header paddingV16" v-show="title">
                    <div class="flexLayout">
                        <div style="width: 16px;"></div>
                        <div class="flexItem alignCenter grey10 fWeight600">{{ title }}</div>
                        <div style="width: 16px;">
                            <i class="icon closeIcon" @click="close()"></i>
                        </div>
                    </div>
                </header>
                <div class="body" style="margin-top: 10px; padding-bottom: 34px;">
                    <div style="text-align: center;">
                        <img class="center" v-if="dataItem && dataItem.headImg" :src="dataItem ? dataItem.headImg : ''"
                             :alt="dataItem ? dataItem.headImg : ''"
                             style="width: 56px;height: 56px;border-radius: 50%;margin-top: 22px;">
                    </div>
                    <form class="form jobRequestForm font14r" action="javascript:;">

                        <div class="form_row" v-if="dataItem && dataItem.name">
                            <label class="block formLabel">姓名</label>
                            <div class="marginT12 formValue">{{ dataItem ? dataItem.name : '' }}</div>
                        </div>

                        <div class="form_row" v-if="dataItem && dataItem.wechatNumber">
                            <label class="block formLabel">微信号</label>
                            <div class="marginT12 formValue">{{ dataItem ? dataItem.wechatNumber : '' }}</div>
                        </div>

                        <div class="form_row" v-if="dataItem && dataItem.phone">
                            <label class="block formLabel">手机号</label>
                            <div class="marginT12 formValue">{{ dataItem ? dataItem.phone : '' }}</div>
                        </div>

                        <div class="form_row" v-if="dataItem && dataItem.educationBackground">
                            <label class="block formLabel">教育学历</label>
                            <div class="marginT12 formValue">{{ dataItem ? dataItem.educationBackground : '' }}</div>
                        </div>

                        <div class="form_row" v-if="dataItem && dataItem.educationCertificate">
                            <label class="block formLabel">教育资格证书</label>
                            <div class="marginT12 formValue">{{ dataItem ? dataItem.educationCertificate : '' }}</div>
                        </div>

                        <div class="form_row" v-if="dataItem && dataItem.jobName">
                            <label class="block formLabel">意向岗位</label>
                            <div class="marginT12 formValue">{{ dataItem ? formatJobName(dataItem.jobName) : '' }}</div>
                        </div>

                        <div class="form_row" v-if="dataItem && (dataItem.salaryMin || dataItem.salaryMax)">
                            <label class="block formLabel">期望薪资</label>
                            <div class="marginT12 formValue">
                                <span>{{ dataItem ? dataItem.salaryMin : '' }}</span>
                                <span>&nbsp;-&nbsp;{{ dataItem ? dataItem.salaryMax : '' }}</span>
                                <span v-if="dataItem && (dataItem.salaryMin || dataItem.salaryMax)">千/月</span>
                            </div>
                        </div>

                        <div class="form_row" v-if="dataItem && dataItem.jobName">
                            <label class="block formLabel">意向工作地</label>
                            <div class="marginT12 formValue">
                                {{ dataItem ? dataItem.province + dataItem.city + dataItem.area : '' }}
                            </div>
                        </div>

                        <div class="form_row" v-if="dataItem && dataItem.workExperience">
                            <label class="block formLabel">工作经验</label>
                            <div class="marginT12 formValue"
                                 style="font-size: 16px;ont-weight: 400;line-height: 24px;color: #333333;">
                                {{ dataItem ? dataItem.workExperience : '' }}
                            </div>
                        </div>

                        <div class="form_row" v-if="dataItem && dataItem.resume">
                            <label class="block formLabel">简历</label>
                            <div>
                                <div :href="dataItem && dataItem.resume ? dataItem.resume : 'javascript:;'">
                                    <img class="cover roundBorder4" :src="dataItem ? dataItem.resume : ''"
                                         v-gallery="imageGroup"
                                         style="width: 80px;height: 80px;"/>
                                </div>
                            </div>
                        </div>

                    </form>

                    <div>
                        <button class="block button yellowButton" style="padding: 0;
                line-height: 42px; height: 42px; border-radius: 20px;" @click="close()">关闭
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import drawerPart from '@comp/part/drawerPart';

import Vue from "vue";
import gallery from "img-vuer";

Vue.use(gallery, {
    swipeThreshold: 150, // default 100
    isIndexShow: true, // show image index, default true
    useCloseButton: true, // trigger gallery close with close button, default true
    preload: true, // preload images in the same group, default true
    sliderBackgroundColor: "rgba(0,0,0,0.6)",
    sliderZIndex: 1001,
});

// config
import appConfig from '@/appConfig';

const config = {
    apiConfig: {
        get: {
            url: appConfig.apiBaseUrl + 'portal/recruit/seeker/get'
        }
    }
};

export default {
    name: "jobRequestDetailDrawer",
    extends: drawerPart,
    props: {
        title: {
            type: String,
            default: '标题'
        }
    },
    data() {
        return {
            apiConfig: config.apiConfig,
            enableDataItem: true,
            imageGroup : 'imageGroup'
        }
    },
    methods: {
        formatJobName(jobNames) {
            if (jobNames.length) {
                return jobNames.join("、");
            }
            return "无期望岗位";
        },
    }
}
</script>

<style lang="scss" scoped>
.header {
    .closeIcon {
        width: 14px;
        height: 14px;
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAACFklEQVRoge2ZQU/bMBhALWCdhPgZvfnk7305k/MkdhgwumqI/vkxpE2CaTsgtaG7xCjqbEiKnWRSntRDqzp+L0nbNDZmYmIiCHBsrT0Z2sNaewIcdxqkqh+AP8CjiHzO5PYqIvIJeAR+q2rZdtwhcAts68daVc8zegZR1Qtg3fC4NcYcvDoQeAc8NAb6iIv82s8OlzvyW+DeGHPYdgNLEakCEdmPRGDPb4EnEbnqtCERWfUdISJXEfnVvhsMRgCXadWf5TfJ5BsbDkVsnHNf0qhnlG9MkC0iu3xjouQRIfl6jpuU7s0Jk0XE5FX1Ood7c+I3Rwwm3xDYO8I5txhU3rNPBLAEqsHlPV0iRifvaRMxWnnPSxEheWA88p5YROC1ClgO7RtERL4GflX/D3lPfdr8E1EfiXHLG2OMql4HTpvkF4BZeEF+/BEh+fr57uk0vojInq+AZeQzMZ6IiPzGObfw74lFJL/m70pMPvQHPBQhItVgEV3kPaOJAG66ynsGjxCRFfC0j7xnsIgU8p7eI1LKe3qLiMiv3yLvyR4Rk095szdbRB/ynuQRfcp7kkWo6qJveQ+BtYE6ot1KkbV2BvzalSfDHekYkTWCe2vtrM34A+B786uyz9UZj6qe70R8M22WmIwxpiiKU+AO+CEiZ3lV4zjnPgI/gbuiKE47DS7L8mg+n7/P5NYaa+2sLMujoT0mJsbKX2RBsPwpegpvAAAAAElFTkSuQmCC');
    }
}

.jobRequestForm {
    .form_row {
        padding: 20px 0 10px;
        border-bottom: 1px solid #f0f0f0;
    }

    .formLabel {
        color: #8994a9;
        margin-bottom: 12px;
    }

    .formValue {
        min-height: 34px;
        line-height: 34px;
        background: #f5f5f5;
        color: #333333;
        padding: 0 8px;
        word-wrap: break-word;
        word-break: break-all;
        font-size: 18px;
        font-weight: 500;
        color: #333333;
    }
}
</style>
